import React from 'react';
import { trackEvent } from '../utils/analytics';

const AnalyticsForm = ({ children, name }) => {
  const handleAnalytics = (e) => {
    e.preventDefault();
    trackEvent('Form', 'Submit', `${name} - Start`);

    if (children.props.onSubmit) {
      children.props.onSubmit(e);
    }
  };

  return React.cloneElement(children, {
    onSubmit: handleAnalytics
  });
};

export default AnalyticsForm; 